import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, forkJoin } from "rxjs";
import { CitiesDTO } from "src/app/Reference/cities/cities.interface";
import { CitiesService } from "src/app/Reference/cities/cities.service";
import { CountryDTO } from "src/app/Reference/country/country.interface";
import { CountryService } from "src/app/Reference/country/country.service";
import { StateDTO } from "src/app/Reference/state/state.interface";
import { StateService } from "src/app/Reference/state/state.service";

@Injectable({
    providedIn: 'root'
})
export class LocationService {
    countryService = inject(CountryService)
    stateService = inject(StateService)
    citiesService = inject(CitiesService)

    countries$ = this.countryService.countries$
    states$ = this.stateService.states$
    cities$ = this.citiesService.cities$


    fetchAllLocations() {
        forkJoin({
            countries: this.countryService.Country_ReadAll(),
            states: this.stateService.State_ReadAll(),
            cities: this.citiesService.Cities_ReadAll()
        }).subscribe()
    }
}